require('isomorphic-fetch');
require('es6-promise').polyfill();

export default (url, options) => {
    let retries = 3
    let retryDelay = 1000
    let retryOn = []

    if (options && options.retries) {
        retries = options.retries;
    }

    if (options && options.retryDelay) {
        retryDelay = options.retryDelay;
    }

    if (options && options.retryOn) {
        if (options.retryOn instanceof Array) {
            retryOn = options.retryOn;
        } else {
            const err = {
                name: 'ArgumentError',
                message: 'retryOn property expects an array'
            }
            throw err
        }
    }

    return new Promise((resolve, reject) => {
        const wrappedFetch = (n) => {
            fetch(url, options).then((response) => {
                if (retryOn.indexOf(response.status) === -1) {
                    resolve(response)
                } else {
                    if (n > 0) {
                        retry(n)
                    } else {
                        resolve(response)
                    }
                }
            }).catch(error => {
                if (n > 0) {
                    retry(n)
                } else {
                    reject(error)
                }
            })
        }

        let retry = (n) => {
            setTimeout(function () {
                wrappedFetch(--n)
            }, retryDelay)
        }
        wrappedFetch(retries)
    })
}